"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Rating = _interopRequireDefault(require("./Rating"));

var _Leaves = _interopRequireDefault(require("./Leaves"));

var _Audit = _interopRequireDefault(require("./Audit"));

var TabPane = _antd.Tabs.TabPane;

var Report = function Report() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Tabs, {
    defaultActiveKey: "1"
  }, /*#__PURE__*/_react.default.createElement(TabPane, {
    tab: "Leaves",
    key: "1"
  }, /*#__PURE__*/_react.default.createElement(_Leaves.default, null)), /*#__PURE__*/_react.default.createElement(TabPane, {
    tab: "Rating",
    key: "2"
  }, /*#__PURE__*/_react.default.createElement(_Rating.default, null)), /*#__PURE__*/_react.default.createElement(TabPane, {
    tab: "Audit",
    key: "5"
  }, /*#__PURE__*/_react.default.createElement(_Audit.default, null))));
};

var _default = Report;
exports.default = _default;